// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Yobs","requiredAsterisk":"Info_requiredAsterisk__3XJ2z"};